import {
  Configuration,
  CreateCustomerRequest,
  CustomersApi,
  NewCustomerRequest,
  UpdateCustomerRequest,
  ViewCustomer
} from "collins-js-sdk";
import { getEnvironmentProps } from "../../utils/environment";
import { dmnIdentity } from "../../utils/dmnIdentity";
import { errorHandler } from "../errorHandler";
import { convertAllDatesToUTC } from "../../utils/helpers";

export const addOrUpdateCustomer = async (customer: ViewCustomer) => {
  customer.lastUpdated = new Date();
  if (customer.id) {
    const response = await updateCustomer({
      customerId: customer.id,
      viewCustomer: customer
    });
    if (!response?.customer?.id) {
      console.error("Customer not updated");
    }
  } else {
    const response = await addCustomer({
      newCustomerRequest: customer as NewCustomerRequest
    });
    if (!response?.customer?.id) {
      console.error("Customer not created");
    }
  }
};

export const patchCustomer = async (
  customer: ViewCustomer,
  update: Partial<ViewCustomer>
) => {
  if (customer.id) {
    customer.lastUpdated = new Date();
    const response = await updateCustomer(
      {
        customerId: customer.id,
        viewCustomer: { ...update }
      },
      {
        method: "PATCH"
      }
    );
    if (!response?.customer?.id) {
      console.error("Customer not updated");
    }
  }
};

export const addCustomer = async (params: CreateCustomerRequest) => {
  const token = await dmnIdentity.getAccessToken();
  const environmentVars = getEnvironmentProps(token);

  const config = new Configuration({
    accessToken: token,
    basePath: environmentVars?.COLLINS_API_BASE_URL
  });

  try {
    const apiResponse = await new CustomersApi(config).createCustomer(params);
    return apiResponse ?? {};
  } catch (error) {
    errorHandler(error, "Error creating customer");

    return {};
  }
};

export const updateCustomer = async (
  params: UpdateCustomerRequest,
  initOverrides?: RequestInit | undefined
) => {
  const token = await dmnIdentity.getAccessToken();
  const environmentVars = getEnvironmentProps(token);

  const config = new Configuration({
    accessToken: token,
    basePath: environmentVars?.COLLINS_API_BASE_URL
  });

  try {
    const apiResponse = await new CustomersApi(config).updateCustomer(
      convertAllDatesToUTC(params),
      initOverrides
    );
    return apiResponse ?? {};
  } catch (error) {
    errorHandler(error, "Error updating customer details");

    return {};
  }
};
